/* VOYRA — global behaviours */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var isMobile = window.matchMedia('(max-width: 900px)').matches;

  /* ---------- Loading screen ---------- */
  var loader = document.getElementById('SiteLoader');
  if (loader) {
    var hideLoader = function () { loader.classList.add('is-done'); };
    if (reducedMotion || sessionStorage.getItem('voyra-loaded')) {
      hideLoader();
    } else {
      window.addEventListener('load', function () { setTimeout(hideLoader, 350); });
      setTimeout(hideLoader, 2200); /* never block the user */
      sessionStorage.setItem('voyra-loaded', '1');
    }
  }

  /* ---------- Header state ---------- */
  var header = document.getElementById('SiteHeader');
  var progressBar = document.querySelector('.scroll-progress span');
  var onScroll = function () {
    var y = window.scrollY;
    if (header) header.classList.toggle('is-scrolled', y > 24);
    if (progressBar) {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      progressBar.style.transform = 'scaleX(' + (h > 0 ? Math.min(y / h, 1) : 0) + ')';
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Mobile menu ---------- */
  var menu = document.getElementById('MobileMenu');
  var menuToggle = document.getElementById('MenuToggle');
  if (menu && menuToggle) {
    var setMenu = function (open) {
      menu.classList.toggle('is-open', open);
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    };
    menuToggle.addEventListener('click', function () { setMenu(!menu.classList.contains('is-open')); });
    menu.querySelectorAll('a, [data-menu-close]').forEach(function (el) {
      el.addEventListener('click', function () { setMenu(false); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
  }

  /* ---------- Reveal on scroll ---------- */
  if (!reducedMotion && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { revealObserver.observe(el); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Section activation (compression demo, counters) ---------- */
  if ('IntersectionObserver' in window) {
    var activateObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-active');
          entry.target.querySelectorAll('[data-count-to]').forEach(animateCounter);
          activateObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.35 });
    document.querySelectorAll('[data-activate]').forEach(function (el) { activateObserver.observe(el); });
  }

  function animateCounter(el) {
    var target = parseFloat(el.getAttribute('data-count-to'));
    if (isNaN(target)) return;
    if (reducedMotion) { el.textContent = target; return; }
    var start = null, dur = 1600;
    var step = function (ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased);
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  /* ---------- Card tilt (desktop only) ---------- */
  if (finePointer && !reducedMotion) {
    document.querySelectorAll('[data-tilt]').forEach(function (card) {
      var rect;
      card.addEventListener('pointerenter', function () { rect = card.getBoundingClientRect(); });
      card.addEventListener('pointermove', function (e) {
        if (!rect) rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = 'perspective(700px) rotateY(' + (x * 7) + 'deg) rotateX(' + (y * -7) + 'deg) translateY(-6px)';
      });
      card.addEventListener('pointerleave', function () { card.style.transform = ''; });
    });

    /* ---------- Magnetic buttons ---------- */
    document.querySelectorAll('[data-magnetic]').forEach(function (btn) {
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + x * 0.18 + 'px,' + y * 0.22 + 'px)';
      });
      btn.addEventListener('pointerleave', function () { btn.style.transform = ''; });
    });

    /* ---------- Custom cursor ---------- */
    var dot = document.querySelector('.cursor-dot');
    var ring = document.querySelector('.cursor-ring');
    if (dot && ring) {
      var mx = -100, my = -100, rx = -100, ry = -100;
      document.addEventListener('pointermove', function (e) { mx = e.clientX; my = e.clientY; });
      (function cursorLoop() {
        rx += (mx - rx) * 0.16; ry += (my - ry) * 0.16;
        dot.style.transform = 'translate(' + (mx - 3) + 'px,' + (my - 3) + 'px)';
        ring.style.transform = 'translate(' + (rx - 17) + 'px,' + (ry - 17) + 'px)';
        requestAnimationFrame(cursorLoop);
      })();
      document.addEventListener('pointerover', function (e) {
        document.body.classList.toggle('cursor-active', !!e.target.closest('a, button, [data-tilt], input, summary'));
      });
    }
  }

  /* ---------- Hero particles ---------- */
  var particlesCanvas = document.querySelector('.hero-particles canvas');
  if (particlesCanvas && !reducedMotion && !isMobile) {
    var ctx = particlesCanvas.getContext('2d');
    var parts = [], W, H;
    var resize = function () {
      W = particlesCanvas.width = particlesCanvas.offsetWidth;
      H = particlesCanvas.height = particlesCanvas.offsetHeight;
    };
    resize();
    window.addEventListener('resize', resize);
    for (var i = 0; i < 34; i++) {
      parts.push({ x: Math.random(), y: Math.random(), s: Math.random() * 1.6 + 0.4, v: Math.random() * 0.00022 + 0.00006, o: Math.random() * 0.4 + 0.1 });
    }
    var accent = getComputedStyle(document.documentElement).getPropertyValue('--accent').trim() || '#59d9ec';
    (function drawParts() {
      ctx.clearRect(0, 0, W, H);
      parts.forEach(function (p) {
        p.y -= p.v * H * 0.06;
        if (p.y < -0.02) { p.y = 1.02; p.x = Math.random(); }
        ctx.globalAlpha = p.o;
        ctx.fillStyle = accent;
        ctx.beginPath();
        ctx.arc(p.x * W, p.y * H, p.s, 0, Math.PI * 2);
        ctx.fill();
      });
      requestAnimationFrame(drawParts);
    })();
  }

  /* ---------- Before / After slider ---------- */
  document.querySelectorAll('.ba-slider').forEach(function (slider) {
    var range = slider.querySelector('.ba-range');
    var setPos = function (v) { slider.style.setProperty('--pos', v + '%'); };
    if (range) {
      range.addEventListener('input', function () { setPos(range.value); });
      setPos(range.value || 50);
    }
  });

  /* ---------- Hotspots ---------- */
  document.querySelectorAll('[data-hotspots]').forEach(function (root) {
    var spots = root.querySelectorAll('.hotspot');
    var panels = root.querySelectorAll('.hotspot-panel');
    spots.forEach(function (spot) {
      spot.addEventListener('click', function () {
        var id = spot.getAttribute('data-spot');
        spots.forEach(function (s) { s.classList.toggle('is-active', s === spot); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === id); });
      });
    });
    if (spots[0]) spots[0].click();
  });

  /* ---------- Tabs (trip selector & generic) ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-tab]');
    var panels = root.querySelectorAll('[data-tab-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === id); });
      });
    });
  });

  /* ---------- Carousels ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('.testi-carousel, [data-carousel-track]');
    if (!track) return;
    root.querySelectorAll('[data-carousel-prev]').forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    });
    root.querySelectorAll('[data-carousel-next]').forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
    });
  });

  /* ---------- Quantity inputs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value || '1', 10) + parseInt(btn.getAttribute('data-qty-change'), 10);
    input.value = Math.max(parseInt(input.min || '0', 10), v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ================================================================
     CART
     ================================================================ */
  var cartDrawer = document.getElementById('CartDrawer');

  function openCart() { document.body.classList.add('cart-open'); }
  function closeCart() { document.body.classList.remove('cart-open'); }
  window.voyraOpenCart = openCart;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]')) closeCart();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  function refreshCartDrawer(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartDrawer');
        if (fresh && cartDrawer) cartDrawer.innerHTML = fresh.innerHTML;
        var freshCount = doc.querySelector('[data-cart-count-source]');
        if (freshCount) {
          document.querySelectorAll('.cart-count').forEach(function (c) {
            c.textContent = freshCount.getAttribute('data-cart-count-source');
            c.setAttribute('data-count', freshCount.getAttribute('data-cart-count-source'));
          });
        }
        if (openAfter) openCart();
      });
  }

  /* AJAX add to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('disabled', ''); btn.innerHTML = '…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Erreur'); });
        return r.json();
      })
      .then(function () { return refreshCartDrawer(true); })
      .catch(function (err) {
        var msg = form.querySelector('[data-cart-error]');
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('disabled'); btn.innerHTML = label; }
      });
  });

  /* Cart line changes (delegated — drawer content is re-rendered) */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-line-qty'), parseInt(input.value, 10));
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (!rm) return;
    e.preventDefault();
    changeLine(rm.getAttribute('data-line-remove'), 0);
  });
  function changeLine(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    }).then(function () { refreshCartDrawer(false); });
  }

  /* ================================================================
     PRODUCT PAGE
     ================================================================ */
  var productRoot = document.querySelector('[data-product-root]');
  if (productRoot) {
    var productData = null;
    var dataEl = document.getElementById('ProductJson');
    if (dataEl) { try { productData = JSON.parse(dataEl.textContent); } catch (err) { /* noop */ } }

    /* Gallery */
    var slides = productRoot.querySelectorAll('.gallery-slide');
    var thumbs = productRoot.querySelectorAll('.gallery-thumbs button');
    var setSlide = function (i) {
      slides.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
    };
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { setSlide(i); }); });

    /* Variant selection */
    var form = productRoot.querySelector('form[data-ajax-cart]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEl = productRoot.querySelector('[data-price]');
    var availEl = productRoot.querySelector('[data-availability]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    function currentOptions() {
      var opts = [];
      productRoot.querySelectorAll('.option-group').forEach(function (g) {
        var checked = g.querySelector('input:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }
    function onVariantChange() {
      if (!productData || !idInput) return;
      var opts = currentOptions();
      var variant = productData.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!variant) return;
      idInput.value = variant.id;
      var money = function (cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'fr', { style: 'currency', currency: window.voyraCurrency || 'EUR' });
      };
      if (priceEl) priceEl.textContent = money(variant.price);
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (availEl) {
        availEl.classList.toggle('is-out', !variant.available);
        var txt = availEl.querySelector('span:last-child');
        if (txt) txt.textContent = variant.available ? availEl.getAttribute('data-in-stock') : availEl.getAttribute('data-out-stock');
      }
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        if (variant.available) submitBtn.removeAttribute('disabled');
        else submitBtn.setAttribute('disabled', '');
      }
      if (variant.featured_media && typeof variant.featured_media.position === 'number') {
        setSlide(variant.featured_media.position - 1);
      }
    }
    productRoot.querySelectorAll('.option-group input').forEach(function (input) {
      input.addEventListener('change', onVariantChange);
    });

    /* Sticky add-to-cart (mobile) */
    var sticky = document.getElementById('StickyATC');
    var buyBox = productRoot.querySelector('.buy-buttons');
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-shown', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(buyBox);
      var stickyBtn = sticky.querySelector('[data-sticky-add]');
      if (stickyBtn && form) {
        stickyBtn.addEventListener('click', function () {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }
    }
  }

  /* ---------- 3D showroom (lazy model-viewer) ---------- */
  document.querySelectorAll('[data-showroom]').forEach(function (root) {
    var loadBtn = root.querySelector('[data-showroom-load]');
    var src = root.getAttribute('data-model-src');
    if (!src) return;
    var boot = function () {
      if (!window.customElements.get('model-viewer')) {
        var s = document.createElement('script');
        s.type = 'module';
        s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
        document.head.appendChild(s);
      }
      var mv = document.createElement('model-viewer');
      mv.setAttribute('src', src);
      mv.setAttribute('camera-controls', '');
      mv.setAttribute('auto-rotate', '');
      mv.setAttribute('shadow-intensity', '1');
      mv.setAttribute('exposure', '1.1');
      mv.setAttribute('ar', '');
      mv.setAttribute('alt', root.getAttribute('data-model-alt') || 'Vue 3D du produit');
      var stage = root.querySelector('[data-showroom-stage]');
      stage.innerHTML = '';
      stage.appendChild(mv);
      root.querySelectorAll('[data-showroom-fullscreen]').forEach(function (b) {
        b.hidden = false;
        b.addEventListener('click', function () {
          if (stage.requestFullscreen) stage.requestFullscreen();
        });
      });
    };
    if (loadBtn) loadBtn.addEventListener('click', function () { loadBtn.closest('.showroom-cta').hidden = true; boot(); });
  });
})();
